import React, { useState } from "react";
import { Box } from "@mui/material";
import StudyDropDown from "../../common/components/StudyDropDown";
import { useGetStudentsQuery } from "../../api/useGetStudent";
import AssignmentStatusBar from "./components/AssignmentStatusBar";
import ActiveStatusPie from "./components/ActiveStatusPie";
import styled from "@emotion/styled";

const DashboardContainer = styled(Box)({
  padding: "24px",
  width: "100%",
  maxWidth: "100%",
  overflowX: "hidden",
  boxSizing: "border-box",
});

const ContentContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gap: "24px",
  marginTop: "24px",
  gridTemplateColumns: "1fr",
  width: "100%",
  maxWidth: "100%",
  overflowX: "hidden",
  boxSizing: "border-box",
  "@media (min-width: 960px)": {
    gridTemplateColumns: "3fr 2fr",
  },
}));

const AdminDashboard = () => {
  const [selectedStudy, setSelectedStudy] = useState(null);
  const {
    data: students,
    isLoading,
    isError,
    error,
  } = useGetStudentsQuery({
    studyId: selectedStudy,
  });

  const handleStudyChange = (event) => {
    setSelectedStudy(event.target.value);
  };
  return (
    <DashboardContainer>
      <Box mb={3}>
        <StudyDropDown
          selectedStudy={selectedStudy}
          handleStudyChange={handleStudyChange}
        />
      </Box>
      {students && (
        <ContentContainer>
          <AssignmentStatusBar students={students} />
          <ActiveStatusPie students={students} />
        </ContentContainer>
      )}
    </DashboardContainer>
  );
};

export default AdminDashboard;
